
import { defineComponent } from 'vue';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons-vue';
import numeral from 'numeral';

export default defineComponent({
  name: 'PaneItem',
  props: {
    label_left: {
      type: String,
      default: () => undefined,
    },
    size: {
      type: String,
      default: () => undefined,
    },
    item_left_1: {
      type: Object,
      default: () => undefined,
    },
    item_left_2: {
      type: Object,
      default: () => undefined,
    },
    is_up: {
      type: Boolean,
      default: () => undefined,
    },
    icon: {
      type: String,
      default: () => 'create_up',
    },
    item_center_1: {
      type: Object,
      default: () => undefined,
    },
    item_center_2: {
      type: Object,
      default: () => undefined,
    },
    label_right: {
      type: String,
      default: () => undefined,
    },
    item_right: {
      type: [Boolean, Object],
      default: () => undefined,
    },
  },
  setup() {
    return {
      numeral,
    };
  },
  components: {
    CaretUpOutlined,
    CaretDownOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
  },
});
